(function () {
  'use strict';

  function safeUrl(value) {
    try {
      return value ? new URL(value) : null;
    } catch (error) {
      return null;
    }
  }

  function getOrCreateLandingPage() {
    var storageKey = 'gvs_landing_page';
    var landingPage = '';

    try {
      landingPage = window.sessionStorage.getItem(storageKey) || '';

      if (!landingPage) {
        landingPage =
          window.location.origin +
          window.location.pathname +
          window.location.search;

        window.sessionStorage.setItem(storageKey, landingPage);
      }
    } catch (error) {
      landingPage =
        window.location.origin +
        window.location.pathname +
        window.location.search;
    }

    return landingPage;
  }

  function initialiseForm(container) {
    if (
      !container ||
      container.dataset.gvsTrackingReady === 'true'
    ) {
      return;
    }

    var currentUrl = safeUrl(window.location.href);
    var referrerUrl = safeUrl(document.referrer);
    var landingPage = getOrCreateLandingPage();

    function getParam(name) {
      if (
        currentUrl &&
        currentUrl.searchParams.get(name)
      ) {
        return currentUrl.searchParams.get(name);
      }

      if (
        referrerUrl &&
        referrerUrl.searchParams.get(name)
      ) {
        return referrerUrl.searchParams.get(name);
      }

      return '';
    }

    var values = {
      landing_page: landingPage,
      current_url: window.location.href,
      referrer: document.referrer || '',
      utm_source: getParam('utm_source'),
      utm_medium: getParam('utm_medium'),
      utm_campaign: getParam('utm_campaign'),
      utm_content: getParam('utm_content'),
      utm_term: getParam('utm_term'),
      gclid: getParam('gclid'),
      msclkid: getParam('msclkid'),
      fbclid: getParam('fbclid')
    };

    var attributionParts = [];

    if (
      values.utm_source ||
      values.utm_medium ||
      values.utm_campaign
    ) {
      attributionParts.push(
        [
          values.utm_source || 'unknown source',
          values.utm_medium || 'unknown medium',
          values.utm_campaign || 'unknown campaign'
        ].join(' / ')
      );
    }

    if (values.utm_content) {
      attributionParts.push(
        'content: ' + values.utm_content
      );
    }

    if (values.utm_term) {
      attributionParts.push(
        'term: ' + values.utm_term
      );
    }

    if (values.gclid) {
      attributionParts.push(
        'gclid: ' + values.gclid
      );
    }

    if (values.msclkid) {
      attributionParts.push(
        'msclkid: ' + values.msclkid
      );
    }

    if (values.fbclid) {
      attributionParts.push(
        'fbclid: ' + values.fbclid
      );
    }

    values.attribution = attributionParts.length
      ? attributionParts.join(' | ')
      : 'No campaign parameters detected';

    Object.keys(values).forEach(function (key) {
      var input = container.querySelector(
        '[data-gvs-ca-track="' + key + '"]'
      );

      if (input) {
        input.value = values[key];
      }
    });

    container.dataset.gvsTrackingReady = 'true';
  }

  function initialiseAll(root) {
    var scope = root || document;

    scope
      .querySelectorAll('[data-gvs-commercial-form]')
      .forEach(initialiseForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initialiseAll(document);
      }
    );
  } else {
    initialiseAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialiseAll(event.target);
    }
  );
})();